module.exports = __webpack_public_path__ + "static/the-workers-912589e2bcbb033fa3c29e94149db688.svg";